<template lang="pug">
v-hover(v-slot='{ hover }' :open-delay='200' :close-delay='200' disabled='')
  v-expansion-panels(hover='' dense='' :value='hover ? 0 : undefined')
    v-expansion-panel
      v-card
        v-expansion-panel-header
          v-card-title {{$t(&grave;pd.${setsn}.name&grave;)}}
        v-expansion-panel-content
          v-card-subtitle ({{$t(&grave;pd.${setsn}.period&grave;)}})
          v-card-text {{$t(&grave;pd.${setsn}.desc&grave;)}}
</template>

<script>
import { ref, toRefs, defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'SetInfo',
  props: {
    setsn: {},
  },
  setup(props, {emit}) {
    const {setsn} = toRefs(props)
    return {
    }
  },
})
</script>
